export default function getNumberValue(str) {
  return Number(`${str}`.replace(/[^0-9.-]+/g, ''));
}
